/* eslint-disable  @typescript-eslint/no-explicit-any */

const setLastItem = (chartState: any): void => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (chartState.state.activeTooltipIndex >= 0) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const lastIndex = chartState.props.data.length - 1;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
    const activeItem = chartState.state.formattedGraphicalItems[0]?.props.points[lastIndex];
    if (!activeItem) {
        return;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
    chartState.setState(
        {
            activeTooltipIndex: lastIndex,
        },
        () => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
            chartState.handleItemMouseEnter({
                tooltipPayload: [activeItem],
                tooltipPosition: {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
                    x: activeItem.x,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
                    y: activeItem.y,
                },
            });
        }
    );
};

export default setLastItem;
